import { createContext, useCallback, useContext, useState } from 'react';
import { useStorage } from '../hooks/storage';
import { getDismissedTaskCards, dismissTaskCard } from '../utils/dismissedTaskCards';
import { jsx as _jsx } from "react/jsx-runtime";
export const TaskCardsContext = /*#__PURE__*/createContext({
  dismissedTaskCards: [],
  dismissTaskCard() {}
});
export const TaskCardsContextProvider = ({
  children
}) => {
  const storage = useStorage();
  const [dismissedTaskCards, setDismissedTaskCards] = useState(() => getDismissedTaskCards(storage));
  return /*#__PURE__*/_jsx(TaskCardsContext.Provider, {
    value: {
      dismissedTaskCards,
      dismissTaskCard: useCallback(groupKey => {
        const newDismissedTaskCards = dismissTaskCard(storage, groupKey);
        setDismissedTaskCards(newDismissedTaskCards);
      }, [storage])
    },
    children: children
  });
};
export const useDismissedTaskCards = () => {
  const dismissedTaskCardsContext = useContext(TaskCardsContext);
  return dismissedTaskCardsContext.dismissedTaskCards;
};
export const useDismissTaskCard = () => {
  const dismissedTaskCardsContext = useContext(TaskCardsContext);
  return dismissedTaskCardsContext.dismissTaskCard;
};
export const useIsTaskCardDismissed = groupKey => {
  return useDismissedTaskCards().includes(groupKey);
};